import { useEffect, useState } from "react";
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import React from "react";
import {
  IGatewaysModel,
  IPlaceWorkFlowModel,
  IPlaceWorkFlowUserModel,
} from "../modules/services/core/_models";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../modules/auth";
import moment from "moment";

interface User {
  Id: number;
  Email: string;
  Name: string;
}

interface IPlaceWorkFlowModelExtended extends IPlaceWorkFlowModel {
  UsuarioOwner: string;
  UsuarioResponsible: string;
}

const formatarTempoRelativo = (data: Date) => {
  const agora = new Date();
  const dataAjustada = new Date(data.getTime() - (3 * 60 * 60 * 1000));
  const diferenca = agora.getTime() - dataAjustada.getTime();

  const segundos = Math.floor(diferenca / 1000);
  const minutos = Math.floor(segundos / 60);
  const horas = Math.floor(minutos / 60);
  const dias = Math.floor(horas / 24);

  if (dias > 0) return `Há ${dias} dias, ${horas % 24} horas atrás.`;
  if (horas > 0) return `Há ${horas} horas, ${minutos % 60} minutos atrás.`;
  if (minutos > 0) return `Há ${minutos} minutos atrás.`;
  return `Há ${segundos} segundos atrás.`;
};

const parseDataDDMMYYYY = (data: string): Date => {
  const [dia, mes, ano] = data.split("/").map(Number);
  return new Date(ano, mes - 1, dia);
};

const MenuChamadoGateway: React.FC = () => {
  const [detalhesGateway, setDetalhesGateway] = useState<IGatewaysModel[]>([]);
  const [coments, setComents] = useState<IPlaceWorkFlowUserModel[]>([]);
  const [detalhesAlerta, setDetalhesAlerta] = useState<IPlaceWorkFlowModelExtended[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [newComment, setNewComment] = useState<string>("");
  const [idemail, setIdemail] = useState<number | null>(null);
  const [dataUsers, setDataUsers] = useState<User[]>([]);
  const [userName, setUserName] = useState<string>("");

  const { auth } = useAuth()
  const user = auth?.User
  const emailUsuario = user?.Email
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  // Função para buscar todos os usuários
  const obterUsuarios = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/User`, {
        method: 'GET',
        headers: {
          'Accept': '*/*',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setDataUsers(data);
      } else {
        console.error('Erro ao buscar usuários:', response.statusText);
      }
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
    }
  };

  const handleFecharChamado = async (idWorkFlow: number) => {
    try {
      const response = await fetch(`${backendUrl}/api/PlaceWorkFlow/Close`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          IdWorkFlow: idWorkFlow,
          Close: true
        }),
      });
      if (response.ok) {
        alert("Chamado fechado com sucesso!");
        // Atualize os detalhes do alerta após fechar
        window.location.reload();
      } else {
        alert("Erro ao fechar chamado.");
      }
    } catch (error) {
      alert("Erro ao fechar chamado.");
      console.error(error);
    }
  };

  // Função para obter o ID e nome do usuário logado
  useEffect(() => {
    const obterIdEmail = async () => {
      if (emailUsuario) {
        try {
          const response = await fetch(
            `${backendUrl}/api/User/ByEmail/${emailUsuario}`,
            {
              method: "GET",
              headers: {
                accept: "*/*",
              },
            }
          );
          const responseJson = await response.json();
          if (typeof responseJson === 'number') {
            setIdemail(responseJson);
            // Buscar o nome do usuário
            const userResponse = await fetch(`${backendUrl}/api/User/${responseJson}`);
            if (userResponse.ok) {
              const userData = await userResponse.json();
              setUserName(userData.Name);
            }
          } else if (responseJson && responseJson.id) {
            setIdemail(responseJson.id);
            setUserName(responseJson.Name);
          }
        } catch (error) {
          console.error("Erro ao buscar ID do usuário:", error);
        }
      }
    };

    obterIdEmail();
    obterUsuarios();
  }, [emailUsuario]);

  useEffect(() => {
    const obterDetalhesAlerta = async () => {
      // Pegando o ID diretamente da URL
      const url = window.location.href;
      const idWorkFlow = url.split('IdWorkFlow=')[1];
      console.log("ID do WorkFlow extraído:", idWorkFlow);

      if (idWorkFlow) {
        try {
          const response = await fetch(
            `${backendUrl}/api/PlaceWorkFlow/ByWorkFlow/${idWorkFlow}`,
            {
              method: "GET",
            }
          );
          console.log("URL da requisição:", `${backendUrl}/api/PlaceWorkFlow/ByWorkFlow/${idWorkFlow}`);
          const responseJson = await response.json();
          console.log("Resposta da API:", responseJson);

          // Processar os detalhes do alerta para incluir nomes dos usuários
          const processarAlerta = (alerta: any) => {
            // Buscar usuário requisitante da lista de usuários
            const ownerUser = dataUsers.find(u => u.Id === alerta.IdUsuarioOwner);
            // Buscar usuário responsável da lista de usuários
            const responsibleUser = dataUsers.find(u => u.Id === alerta.IdUsuarioResponsible);

            return {
              ...alerta,
              UsuarioOwner: ownerUser?.Name || 'Usuário não identificado',
              UsuarioResponsible: responsibleUser?.Name || 'Usuário não identificado'
            };
          };

          if (Array.isArray(responseJson)) {
            const alertasProcessados = responseJson.map(processarAlerta);
            setDetalhesAlerta(alertasProcessados);
          } else {
            const alertaProcessado = processarAlerta(responseJson);
            setDetalhesAlerta([alertaProcessado]);
          }
        } catch (error) {
          console.error("Erro ao buscar detalhes do alerta:", error);
        }
      }
    };

    if (dataUsers.length > 0) {
      obterDetalhesAlerta();
    }
  }, [dataUsers]);

  useEffect(() => {
    const obterComentarios = async () => {
      // Pegando o ID diretamente da URL
      const url = window.location.href;
      const idWorkFlow = url.split('IdWorkFlow=')[1];

      if (idWorkFlow) {
        try {
          const response = await fetch(
            `${backendUrl}/api/PlaceWorkFlowUser/ByWorkFlow/${idWorkFlow}`,
            {
              method: "GET",
            }
          );
          const responseJson = await response.json();

          // Buscar informações dos usuários para cada comentário
          const comentariosComNomes = await Promise.all(
            responseJson.map(async (comentario: any) => {
              const userInfo = dataUsers.find(u => u.Id === comentario.IdUser);
              return {
                ...comentario,
                NameUser: userInfo ? userInfo.Name : 'Usuário não identificado'
              };
            })
          );

          setComents(comentariosComNomes);
        } catch (error) {
          console.error("Erro ao buscar comentários:", error);
        }
      }
    };

    if (dataUsers.length > 0) {
      obterComentarios();
    }
  }, [dataUsers]); // Adiciona dataUsers como dependência

  const handleIncluirComentario = async () => {
    const url = window.location.href;
    const idWorkFlow = url.split('IdWorkFlow=')[1];
    console.log("idWorkFlow:", idWorkFlow);
    console.log("newComment:", newComment);
    console.log("idemail:", idemail);

    if (idWorkFlow && newComment.trim() !== "" && idemail) {
      const comentario = {
        IdUser: idemail,
        IdPlaceWorkflow: parseInt(idWorkFlow),
        Comments: newComment,
        DtCriacao: new Date().toISOString(),
        DtAlteracao: new Date().toISOString(),
      };

      try {
        const response = await fetch(
          `${backendUrl}/api/PlaceWorkFlowUser`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(comentario),
          }
        );

        if (response.ok) {
          // Buscar os comentários atualizados após a inclusão
          const comentariosResponse = await fetch(
            `${backendUrl}/api/PlaceWorkFlowUser/ByWorkFlow/${idWorkFlow}`,
            {
              method: "GET",
            }
          );
          const comentariosAtualizados = await comentariosResponse.json();

          // Adicionar os nomes dos usuários aos comentários
          const comentariosComNomes = await Promise.all(
            comentariosAtualizados.map(async (comentario: any) => {
              const userInfo = dataUsers.find(u => u.Id === comentario.IdUser);
              return {
                ...comentario,
                NameUser: userInfo ? userInfo.Name : 'Usuário não identificado'
              };
            })
          );

          setComents(comentariosComNomes);
          setNewComment(""); // Limpa o campo de comentário
          alert("Comentário incluído com sucesso!");
        } else {
          console.error("Erro ao incluir comentário:", await response.json());
          alert("Erro ao incluir comentário. Por favor, tente novamente.");
        }
      } catch (error) {
        console.error("Erro ao incluir comentário:", error);
        alert("Erro ao incluir comentário. Por favor, tente novamente.");
      }
    } else {
      alert("Por favor, preencha o comentário antes de incluir.");
    }
  };

  return (
    <div
      className="d-flex"
      style={{ height: "83vh", backgroundColor: "#f9f9f9", color: "#333" }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "5%",
          padding: "10px",
        }}
      ></div>
      <div style={{ width: "50%", padding: "10px" }}>
        <h1
          style={{
            textAlign: "center",
            color: "#333",
            marginBottom: "0px",
            borderBottom: "0px solid #ccc",
          }}
        >
          Detalhes do Alerta
        </h1>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 3fr",
            gap: "10px",
            padding: "20px",
            border: "2px solid #ccc",
            borderRadius: "10px",
            backgroundColor: "#f9f9f9",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            marginTop: "15px",
          }}
        >
          {detalhesAlerta.map((alerta, index) => (
            <React.Fragment key={index}>
              <div
                style={{
                  fontWeight: "bold",
                  color: "#555",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#f0f0f0",
                }}
              >
                Gateway:
              </div>
              <div
                style={{
                  color: "#333",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#fff",
                }}
              >
                {(() => {
                  try {
                    const data = JSON.parse(alerta.Dados);
                    return data.Gateway || "N/A";
                  } catch (error) {
                    console.error("Erro ao parsear alerta.Data:", error);
                    return "N/A";
                  }
                })()}
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  color: "#555",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#f0f0f0",
                }}
              >
                Nro Chamado:
              </div>
              <div
                style={{
                  color: "#333",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#fff",
                }}
              >
                {alerta.Chamado}
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  color: "#555",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#f0f0f0",
                }}
              >
                Descrição do Gateway:
              </div>
              <div
                style={{
                  color: "#333",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#fff",
                }}
              >
                {alerta.GatewayDescricao || "N/A"}
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  color: "#555",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#f0f0f0",
                }}
              >
                Status do Alerta:
              </div>
              <div
                style={{
                  color: "#333",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#fff",
                }}
              >
                {alerta.Status ? "Fechado" : "Aberto"}
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  color: "#555",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#f0f0f0",
                }}
              >
                Assunto:
              </div>
              <div
                style={{
                  color: "#333",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#fff",
                }}
              >
                {alerta.Assunto}
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  color: "#555",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#f0f0f0",
                }}
              >
                Requisitante:
              </div>
              <div
                style={{
                  color: "#333",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#fff",
                }}
              >
                {alerta.UsuarioOwner}
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  color: "#555",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#f0f0f0",
                }}
              >
                Responsável:
              </div>
              <div
                style={{
                  color: "#333",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#fff",
                }}
              >
                {alerta.UsuarioResponsible}
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  color: "#555",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#f0f0f0",
                }}
              >
                Criação:
              </div>
              <div
                style={{
                  color: "#333",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#fff",
                }}
              >
                {alerta.DataCriacao}
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  color: "#555",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: "#f0f0f0",
                  height: "41.5px",
                }}
              >
                Comentário:
              </div>
              <textarea
                placeholder="Digite um Comentário.."
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                disabled={alerta.Status} // Desabilita o campo se o alerta estiver fechado
                style={{
                  color: "#333",
                  border: "1px solid #ccc",
                  padding: "10px",
                  backgroundColor: alerta.Status ? "#f0f0f0" : "#fff", // Altera a cor de fundo se desabilitado
                  height: "200px",
                  cursor: alerta.Status ? "not-allowed" : "text", // Altera o cursor se desabilitado
                }}
              ></textarea>
              <div> </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  marginTop: "10px",
                  marginBottom: "10px",
                  gap: "10px"
                }}
              >
                {/* Botão Fechar Chamado */}
                {alerta.UsuarioResponsible === userName && !alerta.Status && (
                  <span
                    style={{ display: 'inline-block', cursor: coments.length === 0 ? 'not-allowed' : 'pointer' }}
                    title={coments.length === 0 ? "É necessário incluir ao menos um comentário para fechar o alerta." : ""}
                  >
                    <button
                      style={{
                        padding: "10px 20px",
                        fontSize: "16px",
                        backgroundColor: "#fd2600",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        // O cursor é gerenciado pelo span agora
                        cursor: "pointer",
                        transition: "background-color 0.3s",
                        // Adiciona um estilo visual para quando estiver desabilitado
                        opacity: coments.length === 0 ? 0.6 : 1,
                      }}
                      disabled={coments.length === 0}
                      onClick={() => handleFecharChamado(alerta.IdWorkFlow)}
                    >
                      Fechar Chamado
                    </button>
                  </span>
                )}

                {/* Botão Incluir Comentário */}
                <button
                  style={{
                    padding: "10px 20px",
                    fontSize: "16px",
                    backgroundColor: alerta.Status ? "rgb(253, 38, 0)" : "#4CAF50",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    cursor: alerta.Status ? "not-allowed" : "pointer",
                    transition: "background-color 0.3s",
                  }}
                  onClick={handleIncluirComentario}
                  disabled={alerta.Status}
                >
                  {alerta.Status ? "Alerta Fechado" : "Incluir"}
                </button>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
      {/* Menu lateral de Chamados */}
      <div
        style={{
          width: "50%",
          borderLeft: "1px solid #ccc",
          padding: "5px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <h1
          style={{
            textAlign: "center",
            color: "#333",
            marginBottom: "0px",
            borderBottom: "0px solid #ccc",
          }}
        >
          Comentários
        </h1>
        <section
          style={{
            marginTop: "20px",
            gap: "10px",
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "10px",
            backgroundColor: "#f9f9f9",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          {coments.length > 0 ? (
            [...coments]
              .sort((a, b) => new Date(b.DtCriacao).getTime() - new Date(a.DtCriacao).getTime()) // Ordena do mais recente para o mais antigo
              .map((comentario, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    borderBottom: "1px solid #ddd",
                    padding: "15px",
                    marginBottom: "15px",
                    backgroundColor: "#fff",
                    borderRadius: "5px",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "#333",
                    }}
                  >
                    {comentario.Comments}
                  </div>
                  <div
                    style={{ fontSize: "14px", color: "#555", marginTop: "10px" }}
                  >
                    Por{" "}
                    <span style={{ fontWeight: "bold" }}>{comentario.NameUser}</span>{" "}
                    -{" "}
                    <span>
                      {comentario.DtCriacao &&
                        !isNaN(new Date(comentario.DtCriacao).getTime())
                        ? moment(new Date(comentario.DtCriacao).getTime() - (3 * 60 * 60 * 1000)).format("YYYY-MM-DD HH:mm:ss")
                        : "Data inválida"}
                    </span>
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#777",
                      marginTop: "5px",
                      fontStyle: "italic",
                    }}
                  >
                    {comentario.DtCriacao &&
                      !isNaN(new Date(comentario.DtCriacao).getTime())
                      ? formatarTempoRelativo(new Date(comentario.DtCriacao))
                      : ""}
                  </div>
                </div>
              ))
          ) : (
            <div
              style={{ textAlign: "center", color: "#777", padding: "10px" }}
            >
              Nenhum comentário encontrado.
            </div>
          )}
        </section>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "5%",
          padding: "10px",
        }}
      ></div>
    </div>
  );
};

export default MenuChamadoGateway;
